export default import.meta.ROLLUP_FILE_URL_7seUylahHtvpNi68l1tXZA